<template>
    <div ref="tooltip" >
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                default: ''
            },
            placement: {
                type: String,
                default: 'top'
            },
            animation: {
                type: Boolean,
                default: true
            },
            container: {
                type: [Boolean, String],
                default: false
            },
            delay: {
                type: [Number, String],
                default: 0
            },
            html: {
                type: Boolean,
                default: false
            },
        },

        mounted() {
            $(this.$refs.tooltip).tooltip({
                title: this.title,
                placement: this.placement,
                animation: this.animation,
                container: this.container,
                delay: this.delay,
                html: this.html
            })
        }
    }
</script>
